import { useMutation } from "react-query";
import { queryClient } from "../query";
import { publicAxios, secureAxios } from "../../constant/auth";
import axios from "axios";

export const useCreateUser = (collection) => {
  let query = `/${collection}/`;

  return useMutation(
    (createItem) => {
      return axios
        .post(`http://44.218.240.227:8000${query}`, createItem)
        .then((res) => res.data);
    },
    {
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries(["items", collection]);
      },
    }
  );
};

export const useUserMe = () => {
  let query = `users/me`;

  return useMutation(
    () => {
      return secureAxios.get(`/${query}`).then((res) => res.data);
    },
    {
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries(["items"]);
      },
    }
  );
};

export const useVerifyUserMobile = () => {
  let query = `qe_auth/verify_mobile`;

  return useMutation(
    () => {
      return secureAxios.post(`/${query}`).then((res) => res.data);
    },
    {
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries(["items"]);
      },
    }
  );
};

export const useCreateOTP = (collection) => {
  let query = `${collection}`;

  return useMutation(
    (newItem) => {
      // //(newItem);
      return secureAxios.get(`/${query}`, newItem).then((res) => res.data);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["items", collection]);
      },
    }
  );
};

export const useVerifyUserOTP = () => {
  let query = `qe_auth/verify_otp`;

  return useMutation(
    (createItem) => {
      return secureAxios.post(`/${query}`, createItem).then((res) => res.data);
    },
    {
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries(["items"]);
      },
    }
  );
};
